module.exports = __webpack_public_path__ + "img/logocorto.d2db4f22.svg";